export const emailContentTypes = {
  DIVIDENDS: 'DIVIDENDS',
};
